import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/desconto.msg'

class DescontoService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('descontos', msg)
  }
}

export default new DescontoService()
